// extracted by mini-css-extract-plugin
export default {"title":"UtJss","text":"k3rwd","similarItemsFailure":"gQqCB","faceEmoji":"b9kD3"};